module.exports = __webpack_public_path__ + "static/media/colorHelpGuide.36c92031.png";